import Client from './client';

export default class Shops extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  getRedirectsAndOrderByApp(app, options = {}) {
    return this.makeRequest(`${this.host}/shopify/shops/redirects/${app}/order`, options);
  }

  getByMyshopifyDomain(myshopifyDomain, options = {}) {
    return this.makeRequest(`${this.host}/shopify/shops/${myshopifyDomain}`, options);
  }

  putByMyshopifyDomain(myshopifyDomain, options = {}) {
    return this.makeRequest(`${this.host}/shopify/shops/${myshopifyDomain}`, {
      ...options,
       method: 'PUT',
    });
  }

  deleteByMyshopifyDomain(myshopifyDomain, options = {}) {
    return this.makeRequest(`${this.host}/shopify/shops/${myshopifyDomain}`, {
      ...options,
       method: 'DELETE',
    });
  }

  postInstallByMyshopifyDomain(myshopifyDomain, options = {}) {
    return this.makeRequest(`${this.host}/shopify/shops/${myshopifyDomain}/install`, {
      ...options,
       method: 'POST',
    });
  }

  postSessionsByMyshopifyDomain(myshopifyDomain, options = {}) {
    return this.makeRequest(`${this.host}/shopify/shops/${myshopifyDomain}/sessions`, {
      ...options,
       method: 'POST',
    });
  }

}
